<template>
<!--  点赞详情-->
  <div id="tradeLeadLike">
    <NavBar fixed title="点赞详情" style="background-color: #f7f7f7">
      <template #left>
        <!--		    <Icon name="photograph" size="22" color="#666"/>--><Icon @click="allReturn()" name="arrow-left" size="22" color="#666"/></template>
    </NavBar>
    <div class="indiv" style="background-color: #f7f7f7;height: calc(100vh - 46px);overflow: auto;margin-top: 46px">
      <div class="indiv92" style="background-color: white">
        <ul class="likeUl">
          <li :key="index" v-for="(item, index) in myList">
            <img :src="item.headBigImage"/>
            <p class="NoWrap magtop_4">{{item.nickName}}</p>
          </li>
        </ul>
      </div>
      <div class="textcenter magTB4 font_16" style="color: #a7a7a7">没有更多了</div>
    </div>
  </div>
</template>

<script>
import {Icon, NavBar} from "vant";

export default {
  components: {
    NavBar,
    Icon
  },
  name: 'tradeLeadLike',
  data () {
    return {
      formId: parseInt(this.$route.query.formId),
      myList: []
    }
  },
  created() {
    this.getupUserPage()
  },
  mounted() {
  },
  methods: {
    allReturn () {
      this.$router.go(-1)
    },
    getupUserPage () {
      let data = {
        exploreId: this.formId,
        page: 1,
        size: 999999
      }
      this.$axiox.post('/explore/upUserPage', data).then(msg => {
        this.myList = msg.data.content || []
      })
    }
  }
}
</script>

<style scoped>
.likeUl {
  white-space: normal;
}
.likeUl li {
  display: inline-block;
  width: calc(20% - 20px);
  text-align: center;
  padding: 10px;
}
.likeUl li img {
  width: 80%;
  border-radius: 100%;
}
</style>
